export enum ColorModifierTypes {
  LIGHTEN = 'lighten',
  DARKEN = 'darken',
  MIX = 'mix',
  ALPHA = 'alpha',
}
